import { YOUR_WORK_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import type { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const yourWorkRouteDefinition: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: 'your-work',
	path: YOUR_WORK_PATH,
	layout: 'home',
	featureGating: {
		gates: ['townsquare_your_work_page'],
		behavior: { type: 'enabled' },
	},
});
